export default {
  'application-guider': 'Hướng dẫn sử dụng',
  'application-title': 'Bộ ứng dụng của bạn',
  'documents.guider': 'Hướng dẫn sử dụng',
  'documents.system-directory': 'Danh mục hệ thống',
  'documents.docs': 'Tài liệu hướng dẫn sử dụng',
  'documents.empty': 'Tài liệu trống',
};
